import { DateTime, Settings } from "luxon";
Settings.defaultLocale = "de-CH";
import "./shared/_bezeichnungen.js";

// Append is correct here, because code gets executed only after jQuery.ready event
import "./shared/_helpers.js";
import "./shared/_autocomplete.js";
import "./shared/_verschluesselung.js";
import "./shared/_appMethods.js";
import "./_re-login.js";

let app = window.app;

let dateObjNow = DateTime.local();

// Foundation laden
$(document).foundation();

// jQuery Funktionen aktivieren
$(document).ready(async function () {
  // Load settings, transport types and glossary in parallel
  await Promise.all([
    app.ladeEinstellungen(),
    app.ladeTransporttypen(),
    app.ladeSessiondaten(),
    app.ladeGlossar(),
  ]);
  app.verarbeiteEinstellungen();
  // load ward overview
  await app.ladeStationsubersicht();

  // Tabelle Stationsübersicht Sortierfunktion starten
  $("table#stationsUbersicht").stupidtable();
  app.aktiviereBloodhound();

  if (app.customer?.type == 10) {
    // Load ward overview each 30s
    setInterval(() => {
      app.ladeStationsubersicht()
    }, 30 * 1000);
  }

  /**	Logout-Button submit auslösen
   *
   */
  $("aside").on("click", "#abmeldeButton", function (e) {
    e.preventDefault();

    function testAbgemeldet() {
      $.ajax({
        type: "GET",
        url: app.backend + "/me",
        dataType: "json"
      })
        .done(function (data) {
          console.error("Noch immer angemeldet", { data });
          alert("Abmelden Fehlgeschlagen");
        })
        .fail(function () {
          window.location.href = app.urls;
        });
    }

    function abmelden(_this) {
      $(_this)
        .removeClass("fa-user")
        .addClass("spin fa-refresh")
        .attr("disabled", true);

      $.ajax({
        type: "GET",
        url: app.urls + "/logout", //nicht app.backend!
        dataType: "json"
      })
        .done(function (data) {
          if (data.success) {
            app.anmeldeformDirty = false;
            window.location.href = app.urls;
          } else {
            console.error("Abmelden Fehlgeschlagen", { data });
            testAbgemeldet();
          }
        })
        .fail(function (data, textStatus) {
          console.error("Abmelden Fehlgeschlagen", { textStatus, data });
          testAbgemeldet();
        })
        .always(function () {
          $("#abmeldeButton")
            .removeClass("spin fa-refresh")
            .attr("disabled", false)
            .addClass("fa-check");
        });
    }

    if (app.anmeldeformDirty) {
      fnotify.confirm(
        function (button) {
          if (button === "success") {
            abmelden(this);
          }
        },
        "Wirklich Abmelden und alle Eingaben löschen?",
        "Die Eingaben können nicht wiederhergestellt werden.",
        { success: "OK", alert: "Abbrechen" },
        "small"
      );
    } else {
      abmelden(this);
    }
  });
  // Ende Logout-Button submit auslösen

  // Nach Login ein wenig runterscrollen
  let contentDiv = document.querySelector("article .content");
  if (contentDiv.scrollTop < 50) {
    contentDiv.querySelector("main .button:first-child").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }


  // Startzeit speichern
  app.data.startTime = new Date().getTime();

  // Datumfelder min/max setzen
  $("#i6-datum")
    .attr("min", dateObjNow.minus({ days: 14 }).toISODate())
    .attr("max", dateObjNow.plus({ years: 1 }).toISODate());
  $("#i5-geburtsdatum")
    .attr("min", "1890-01-01")
    .attr("max", dateObjNow.plus({ days: 14 }).toISODate());

  $("#zusammenfassungReveal").one("open.zf.reveal", function () {
    setTimeout(function () {
      app.karte.zeigeRoutingKarte();
    }, 500);
  });
  $("#zusammenfassungReveal").on("open.zf.reveal", function () {
    setTimeout(function () {
      app.karte.getAndDisplayRoute(
        app.karte.waypoints.startPoint,
        app.karte.waypoints.endPoint
      );
    }, 800);
  });

  /**	Transporttypen lösen Prio 1 aus, oder verbieten Abholzeit, triggern app.einsatzAbSofort()
   *
   */
  $("#anmeldeform").on("change", "#i3-transportgrund", function () {
    // Wenn Transporttyp mit Priorität 1 oder 2 ausgewählt wird, Checkbox «ab Sofort» anhaken
    let priority = $(this).find("option:selected").data("priority");

    // Wechsel erfolgt, alles disabled aufheben
    $("#i6-destination, #i6-sofort, #i6-flexibel")
      .prop("disabled", false)
      .parent()
      .prop("disabled", false);
    if (priority === "S1") {
      app.einsatzAbSofort();
      // Wieder disabled machen
      $("#i6-destination, #i6-sofort, #i6-flexibel")
        .prop("disabled", true)
        .parent()
        .prop("disabled", true);
    } else if (priority === "S2") {
      app.einsatzAbSofort();
      $("#i6-destination, #i6-sofort, #i6-flexibel")
        .prop("disabled", true)
        .parent()
        .prop("disabled", true);
    } else {
      // Ein Terminierter Einsatz ist nicht ab sofort
      $("#i6-sofort").prop("checked", false);
      $("#i6-destination").trigger("click");
      $("#i6-sofort").prop("disabled", true).parent().prop("disabled", true);
    }
  });
  // Ende Transporttypen lösen Prio 1 aus, oder verbieten Abholzeit, triggern app.einsatzAbSofort()

  /**	Auswahl der Checkbox «ab Sofort» ändert Datum etc. auf sofort
   *
   */
  $("#i6-sofort").on("click", function () {
    if ($(this).prop("checked")) {
      app.einsatzAbSofort();
    }
  });
  // Ende Auswahl der Checkbox «ab Sofort» ändert Datum etc. auf sofort

  /**	Auswahl von (Rollstuhl-)Taxi reduziert Anzahl required-Felder
   *
   */
  $("[name=i8-fahrzeug]").on("change", function () {
    let requiredEl = "#i2-station" + ", " + "#i4-station";
    if ($(this).prop("id") !== "i8-ktw") {
      // Entferne required
      $(requiredEl).prop("required", false);

      // Stern vom Label entfernen
      $(requiredEl)
        .parent()
        .parent()
        .find("label, .input-group-label")
        .each(function () {
          $(this).text($(this).text().replace("*", ""));
        });

      $("#i7-bemerkungen").removeAttr("data-validator");
    } else {
      // Füge required wieder dazu
      $(requiredEl).prop("required", true);

      // Bei required-Felder ein Stern ans Label anfügen
      $("[required]:not(:radio)")
        .parent()
        .parent()
        .find("label, .input-group-label")
        .each(function () {
          if (!$(this).text().endsWith("*")) {
            $(this).append("*");
          }
        });

      $("#i7-bemerkungen").attr("data-validator", "diagnose");
    }
  });
  // Ende Auswahl der Checkbox «ab Sofort» ändert Datum etc. auf sofort

  /**	Formulareingaben überprüfen
   *
   */
  // Falls Formular invalide ist
  $(document).bind("forminvalid.zf.abide", function () {
    let invalid_fields = $(this).find("[data-invalid]");

    invalid_fields[0].scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });

    app.saveToLog(
      "anmeldeform zf invalid",
      {
        customerId: app.customer.id,
        customerLabel: app.customer.username,
        invalidFields: invalid_fields[0].id
      },
      INFO
    );
    setTimeout(() => {
      $(invalid_fields[0]).focus();
    }, 300);
  });
  // Ende Formulareingaben überprüfen

  /**	Formular abschicken/löschen
   *
   */
  $("#anmeldeform").on("click", "a.button.submit", function (e) {
    e.preventDefault();
    $("#anmeldeform").foundation("validateForm");
  });
  // Formular ist valide
  $("#anmeldeform").on("formvalid.zf.abide", function () {
    try {
      app.getAnmeldeForm(function (mission) {
        app.mission = mission;
        app.zeigeZusammenfassung(app.mission);
      });
    } catch (error) {
      app.saveToLog(
        `Fehler im Anmeldeformular`,
        {
          error,
          customerId: app.customer.id,
          customerLabel: app.customer.username
        },
        ERROR
      );
    }
  });
  // Formular zurücksetzen
  $("#anmeldeform").on("click", "a.button.reset", function (e) {
    e.preventDefault();

    fnotify.confirm(
      function (button) {
        if (button === "success") {
          app.leereFormular(true);
        }
      },
      "Wirklich alle Eingaben löschen?",
      "Die Eingaben können nicht wiederhergestellt werden.",
      { success: "OK", alert: "Abbrechen" },
      "small"
    );
  });

  app.anmeldeformDirty = false;
  $("#anmeldeform").on("input", () => {
    if (!app.anmeldeformDirty) {
      app.anmeldeformDirty = true;
    }
  });
  $(window).on("beforeunload", (e) => {
    if (app.anmeldeformDirty) {
      e.returnValue =
        "Die Eingaben wurden noch nicht gespeichert. Möchtest du die Seite wirklich schliessen?";
      e.preventDefault();
    }
  });

  // HTML-Abschicken-Event abfangen
  $("#anmeldeform").on("submit", function (e) {
    e.preventDefault();
  });

  // Formular aus Zusammenfassung abschicken
  $("#zusammenfassungReveal .button.submit").on("click", function () {
    if ($(this).hasClass("disabled")) {
      return;
    }
    $("#zusammenfassungReveal .button.submit")
      .removeClass("fa-check")
      .addClass("ffab-spin fa-refresh")
      .attr("disabled", true);
    let hasReturnMission = $("#i8-rucktransport-toggle").prop("checked");
    app.speichereNeueMission(app.mission, function (response) {
      if (response.status == "success") {
        app.leereFormular(true);
        if (hasReturnMission) {
          let missionId = response.uuid;
          const options = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({ action: "returning" })
          };
          fetch(`${app.backend}/missions/${missionId}`, options);
        }
        $("#erfolgReveal").foundation("open");
      } else {
        $("#fehlerReveal").foundation("open");
        $("#fehlerReveal .fehlertext").text(
          JSON.stringify(response, undefined, 2)
        );
        throw new Error(
          "app.speichereNeueMission fehlgeschlagen: " + JSON.stringify(response)
        );
      }
      $("#zusammenfassungReveal .button.submit")
        .addClass("fa-check")
        .removeClass("ffab-spin fa-refresh")
        .attr("disabled", false);
    });
  });
  // Ende Formular abschicken/löschen

  if (app.debug) {
    let $button = $("<button>", {
      type: "button",
      class: "button warning ffab before fa-laptop-code"
    }).text("DEV: Formular ausfüllen");
    $("#anmeldeform #i1-container").prepend($button);

    $button.on("click", function () {
      let dateText = DateTime.local().toLocaleString(DateTime.DATETIME_SHORT);
      $("#i1-kontaktperson").val("TEST " + dateText);
      $("#i8-ktw").trigger("click");
      setTimeout(function () {
        $("#i8-lying").trigger("click");
      }, 500);
      $("#i4-bezeichnung").typeahead("val", "KSSG");
      $("#i4-container .columns:first").before(
        $("<small>", { class: "columns small-12 color-warning" }).text(
          "DEV: Spital und Station müssen noch manuell aus Dropdown ausgewählt werden!"
        )
      );
      $("#i3-transportgrund")
        .val($("#i3-transportgrund option:nth-child(2)").val())
        .trigger("change");
      $("#i5-name").val("TEST");
      $("#i5-vorname").val("TEST");
      $("#i5-geburtsdatum").val("2020-09-03");
      $("#i5-fallnummer").val("TEST " + dateText);
      $("#i7-bemerkungen").val("TEST " + dateText);
      $("#i8-monitor").trigger("click");
      if (!$("#i2-bezeichnung").typeahead("val")) {
        $("#i2-bezeichnung").typeahead("val", "Wil");
        $("#i2-station").typeahead("val", "Notfall");
        $("#i2-bezeichnung").focus().typeahead("open");
      } else {
        $("#i4-bezeichnung").focus().typeahead("open");
      }
    });
  }

  /**	Javascript das für Styling benötigt wird
   *
   */
  // Label das input umgibt:
  const labelElements = document.querySelectorAll(
    "label:has(input), label:has(select)"
  );
  for (const el of labelElements) {
    el.classList.add("hasInputChild");
  }

  // Wenn select#i8-perfusor nicht 0 ausgewählt hat
  $("#anmeldeform").on("change", "#i8-perfusor", function () {
    if (Number($(this).val()) === 0) {
      $(this).removeClass("notZero");
    } else {
      $(this).addClass("notZero");
    }
  });

  // #fehlerReveal muss beim Schliessen ein reload machen
  $("#fehlerReveal").on("click", ".button.schliessen", function () {
    window.location.href = app.urls;
  });
  // Ende vom Styling
});
